"use client";

import { X } from "lucide-react";

interface FuelCostFormProps {
  currency: string;
  fuelCost: string;
  setFuelCost: (v: string) => void;
  onClear: () => void;
}

function FuelCostForm({
  currency,
  fuelCost,
  setFuelCost,
  onClear
}: FuelCostFormProps) {
  return (
    <div className="vehicle-form-section">
      <div className="fuel-input-row">
        <div className="autocomplete-with-clear">
          <div className="fuel-input">
            <input
              placeholder="Fuel Cost"
              value={fuelCost}
              onChange={(e) => setFuelCost(e.target.value)}
              className="standard-input"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Escape") {
                  e.currentTarget.blur(); 
                }
              }}
            />
            <button
              onClick={() => onClear()}
              className="close-btn clear-icon"
              tabIndex={-1}
              aria-label="Clear input"
            >
              <X className="sortable-clear-btn"/>
            </button>
          </div>
        </div>
        <button
          className="fuel-consumption-label"
          aria-label="Fuel Consumption label"
          type="button"
        >
          {currency} / L
        </button>
      </div>
    </div>
  );
}

export default FuelCostForm;